import { writable } from 'svelte/store';

export default writable({
    filters_list: [],
	product_sizes: []
})